@if (initialized && contractsRuntime) {

  <div class="card mb-5 p-0">
    <div class="p-5">
      <h3 class="text-color">Verträge</h3>
      <p class="text-color-secondary mb-5">Gut organisiert, schnell gefunden.</p>

      <div class="mb-5 flex flex-wrap gap-2">

        @for (insurableObject of uiInsurableObjects; track insurableObject.id) {
          <p-button
            [styleClass]="'px-1 h-3rem border-2 ' + (selectedInsurableObjectMap?.has(insurableObject.id)
              ? 'bg-primary-50 border-blue-500 text-primary font-semibold' : 'surface-border text-color-secondary')"
            [outlined]="true"
            (click)="handleInsurableObject(insurableObject)">

            <div class="flex align-items-center">
              <img insurableObjectImage [insurableObject]="insurableObject" class="p-2 border-circle w-3rem h-3rem"/>

              <div class="ellipses-1">
                {{ insurableObject.name }}
              </div>

              <div class="md:mx-3 mx-1">
                <p-badge styleClass="bg-bluegray-400 flex justify-content-center align-items-center"
                         severity="info" [value]="insurableObject.numberOfContracts.toString()"
                         [style]="{'width': '1.3rem', 'height': '1.3rem'}"></p-badge>
              </div>
            </div>
          </p-button>
        }
        @if (selectedInsurableObjectMap) {
          <p-button
            [outlined]="true"
            icon="pi pi-times text-red-500"
            (click)="clearAllInsurableObjects()"
            [styleClass]="'h-3rem border-2 surface-border text-color-secondary'">
          </p-button>
        }
      </div>
    </div>
    <div class="flex flex-wrap justify-content-between py-3 px-5 mb-2 surface-50 gap-3">
    <div class="flex gap-3 align-items-center">
<!-- Ticket# 1000000537-->
      <p-selectButton
        [options]="statusOptions"
        [(ngModel)]="selectedStatusOptions"
        (onChange)="handleFilters()"
        [allowEmpty]="false"
        styleClass="p-0"
        optionLabel="statusName">
        </p-selectButton>
      <p-progressSpinner *ngIf="busy" styleClass="w-2rem h-2rem"></p-progressSpinner>
    </div>

      <div class="flex justify-content-between gap-3 sm:flex-row flex-column">

        <p-multiSelect
          [options]="contractsRuntime.groups"
          [(ngModel)]="selectedCategory"
          (onChange)="handleFilters()"
          (onSelectAllChange)="onSelectAllCategory($event)"
          [showToggleAll]="true"
          [selectAll]="selectAll"
          styleClass="w-19rem"
          optionLabel="name"
          [showClear]="true"
          (onClear)="handleFilters()"
          placeholder="Kategorie">
          <ng-template let-item pTemplate="item">
            <div class="flex gap-2 align-items-center">
              {{ item.name }}
              <p-badge styleClass="surface-300" [value]="item.contracts"></p-badge>
            </div>
          </ng-template>
        </p-multiSelect>

        <p-selectButton
          [options]="displayOptions"
          optionLabel="icon"
          optionValue="displayValue"
          [allowEmpty]="false"
          styleClass="lg:block hidden"
          (onChange)="handleChangeDisplay($event)"
          [(ngModel)]="displayValue">
          <ng-template let-item pTemplate>
            <i [class]="item.icon"></i>
          </ng-template>
        </p-selectButton>

      </div>

    </div>
    @if (displayValue == 'table') {

      <app-contracts-browse [uiContracts]="uiContracts" source="ds/home"></app-contracts-browse>
    }

    @if (displayValue == 'list') {
      <p-dataView #dv [value]="uiContracts">
        <ng-template pTemplate="list" let-contract>

          <div class="grid grid-nogutter lg:px-3 px-2">
            <div class="col-12  lg:col-6 xl:col-3 lg:p-3 p-2 mb-2"
                 *ngFor="let contract of uiContracts; let first = first">
              <div (click)="showContract(contract)"
                   class="p-3 border-1 border-300 surface-card border-round h-full hover:border-primary-500 cursor-pointer">
                <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                  @if (contract.notFullyManaged) {
                    <span class="flex">
                              <i class="pi pi-exclamation-triangle text-red-500"></i>
                          </span>
                  }
                  <span class="flex align-items-center gap-2">
                            <i class="pi pi-tag"></i>
                            <span class="font-semibold">{{ contract?.insuranceIdentNumber }}</span>
                        </span>
                  <p-tag [value]="contract?.contractStatusText" styleClass="px-3" class="text-center" [rounded]="true"
                         icon="pi pi-circle-fill mr-2"
                         [severity]="contract?.contractStatus == 0 ? 'success' : contract?.contractStatus == 1 ? 'danger' :'warning'"></p-tag>
                </div>
                <div class="flex flex-column align-items-center gap-3 pt-4">
                  <div
                    class="w-6 h-6rem flex justify-content-center align-items-center border-round p-2 text-center overflow-hidden">
                    @if (contract.insuranceCompany?.imageUrl) {
                      <img style="object-fit: contain;" class="w-full"
                           [src]="contract.insuranceCompany?.imageUrl" [alt]="contract.insuranceCompany?.name"/>
                    } @else {
                      {{ contract?.insuranceCompany?.name }}
                    }
                  </div>
                  <div class="text-xl font-normal text-center text-900"
                       style="word-brek: break-word">{{ contract?.insuranceType?.name }}
                  </div>

                  <span class="">
                      <span class="font-normal">
                        @if (contract?.freePayment) {
                          Beitragsfrei
                        } @else if (contract?.cost) {
                          {{ contract?.cost?.formattedAmount }}
                          /{{ contract?.paymentFrequencyText }}
                        } @else {
                          -
                        }
                        </span>
                  </span>

                  <!-- ****************** INSURABLE OBJECTS ****************** -->
                  <span class="flex flex-wrap lg:gap-3 gap-4 my-2 justify-content-">
                      @for (object of contract.insurableObjects; track object.id) {
                        <p-chip styleClass="border-round-md px-3 surface-100 text-color object-img ">
                          <img insurableObjectImage [insurableObject]="object" class="mr-3 w-3rem h-3rem"/>
                          <span class="ellipses-1">{{ object.name }}</span>
                        </p-chip>

                      }
                        </span>
                </div>
              </div>
            </div>
          </div>

        </ng-template>
      </p-dataView>

    }

  </div>
}

